import { Component, inject, input, signal } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { Contact, FormState } from '../contact-apartment.component';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ApiService, ContactPayload } from '../../../../services/api.service';
import { ButtonComponent } from '../../../common/button/button.component';

@Component({
    selector: 'app-contact-form',
    imports: [
        ButtonComponent,
        NgIf,
        RouterLink,
        TranslatePipe,
        FormsModule,
        ReactiveFormsModule,
    ],
    templateUrl: './contact-form.component.html',
})
export class ContactFormComponent {
    data = input.required<Contact>();
    formStateEnum = FormState;
    formState = signal<FormState>(FormState.Idle);
    form!: FormGroup;
    private fb: FormBuilder = inject(FormBuilder);
    private apiService: ApiService = inject(ApiService);

    ngOnInit() {
        this.form = this.fb.group({
            name: ['', [Validators.required, Validators.maxLength(50)]],
            email: ['', [Validators.required, Validators.email]],
            message: [
                '',
                [
                    Validators.required,
                    Validators.minLength(10),
                    Validators.maxLength(500),
                ],
            ],
            privacyPolicy: [false, Validators.requiredTrue],
        });
    }

    createContactEntry(): ContactPayload {
        return {
            data: {
                name: this.form.get('name')?.value,
                email: this.form.get('email')?.value,
                message: this.form.get('message')?.value,
                contactTo: 'apartment',
            },
        };
    }

    onSubmit() {
        this.formState.set(FormState.Submitting);
        if (this.form.valid) {
            this.apiService
                .createContactEntry(this.createContactEntry())
                .subscribe({
                    next: () => {
                        this.form.reset();
                        this.formState.set(FormState.Success);
                    },
                    error: () => this.formState.set(FormState.Error),
                });
        } else {
            this.formState.set(FormState.Invalid);
        }
    }
}
